import { TermItem } from '../../../../graphql/graphql';
import { InsuranceCompanyCheckboxItem } from './buildInsuranceCompaniesCheckboxScheme';

export function formatInsuranceCompany(
	insuranceCompany: TermItem | undefined,
	showName?: boolean,
) {
	if (!(insuranceCompany?.value && insuranceCompany?.value2)) {
		return '';
	}

	return `${insuranceCompany.value} - ${insuranceCompany.value2}${
		showName && insuranceCompany?.name ? `(${insuranceCompany?.name})` : ''
	}`;
}

export function formatInsuranceCompaniesOptions(data?: TermItem[] | null) {
	if (data) {
		return data
			.map(item => ({
				key: item?.value2,
				title: formatInsuranceCompany(item),
			}))
			.filter(
				(item): item is InsuranceCompanyCheckboxItem =>
					!!item.key && !!item.title,
			);
	}

	return [];
}
